import { spawn } from 'redux-saga/effects';

import { openNotification } from './openNotification';

import { notificationType } from '../constants/notification';

export function* onError(error) {
  yield spawn(openNotification, notificationType.error, error.message ?? 'global.unknownServerError', error.message);
}
